const cache = new Map();
const DEFAULT_TTL_MS = 1000;

function isCacheEntryValid(entry, ttlMs) {
  if (!entry) return false;
  if (entry.promise) return true;
  return Date.now() - entry.timestamp < ttlMs;
}

export function getCachedOrFetch(key, fetcher, ttlMs = DEFAULT_TTL_MS) {
  const entry = cache.get(key);

  if (isCacheEntryValid(entry, ttlMs)) {
    return entry.promise || Promise.resolve(entry.data);
  }

  const promise = fetcher().then((data) => {
    cache.set(key, {data, timestamp: Date.now(), promise: null});
    return data;
  });

  cache.set(key, {data: null, timestamp: 0, promise});
  return promise;
}

export function clearFetchCache(key) {
  if (key) {
    cache.delete(key);
  } else {
    cache.clear();
  }
}
